import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Textarea from './components/Textarea';
import Footer from './components/Footer';


function App() {
  return (
    <>
  
    <Navbar title= "@TextApp"/>

  <div className="container my-3">
    <Textarea heading='Enter text here to analyze...'/>
  </div>



<div className="container">
  <hr />
    <Footer/>
</div>

    </>
  );
}

export default App;
